import { Component, Input, OnInit, ViewChild } from '@angular/core';
import _ from 'lodash';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { ToastService } from 'app/toast/services/toast.service';

let id = 1;

@Component({
  selector: 'app-shared-link-option-popover',
  templateUrl: './shared-link-option-popover.component.html',
  styleUrls: ['./shared-link-option-popover.component.scss']
})
export class SharedLinkOptionPopoverComponent implements OnInit {

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() campaign:any
  @Input() option:any

  private _id = id++;
  get id() {
    return `SharedLinkOptionPopover_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  getQRUrl(campaign) {
    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
    const intid = _.get(campaign, 'intid', 0);
    const itemId = this.option.id;
    const action = this.option.buyItNowOnlyItem ? 'buy' : 'bid'
    return window.location.protocol + "//" + window.location.hostname  + "/quickpay.html?handle=" + handle + "&ppid=" + intid + "&itemId=" + itemId + "&action=" + action
  }

  onCopyToClipboard() {
    this.toastService.show('success', 'Link was copied')
  }

  shareFB(campaign) {
    window['FB'].ui({
      method: 'share',
      href: this.getQRUrl(campaign),
      quote: campaign.name,
    }, function(response){});

  }

  shareTwitter(campaign) {
    const url = this.getQRUrl(campaign);
    const href = `https://twitter.com/intent/tweet?text=${campaign.name}&url=${url}&referrer=twitter`
    window.open(href, "_blank");
  }

  onClickDownload() {
    window['orgMain'].downloadOptionCallback(this.campaign,this.option);
  }

}
